import googleTwoFactorAuthSetup from '../../../../components/googleTwoFactorAuthSetup/googleTwoFactorAuthSetup.vue';
import smsTwoFactorAuthSetup from '../../../../components/smsTwoFactorAuthSetup/smsTwoFactorAuthSetup.vue';
import accountingSetupTripletex from '../../../../components/accountingSetupTripletex/accountingSetupTripletex.vue';
import marketplaceModuleSetup from '../../../../components/marketplaceModuleSetup/marketplaceModuleSetup.vue';
import vinmonopoletModuleSetup from '../../../../components/vinmonopoletModuleSetup/vinmonopoletModuleSetup.vue';
import accountingSetupVisma from '../../../../components/accountingSetupVisma/accountingSetupVisma.vue';
import accountingSetupFiken from '../../../../components/accountingSetupFiken/accountingSetupFiken.vue';
import accountingSetupPowerOffice from '../../../../components/accountingSetupPowerOffice/accountingSetupPowerOffice.vue';
import ehfModuleSetup from '../../../../components/ehfModuleSetup/ehfModuleSetup.vue';
import unimicroModuleSetup from '../../../../components/unimicroModuleSetup/unimicroModuleSetup.vue';


export default {
  googleTwoFactorAuthSetup,
  smsTwoFactorAuthSetup,
  accountingSetupTripletex,
  marketplaceModuleSetup,
  vinmonopoletModuleSetup,
  accountingSetupFiken,
  ehfModuleSetup,
  accountingSetupVisma,
  accountingSetupPowerOffice,
  unimicroModuleSetup,
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/modules/components/index.js